<div class="calendar-input" [class.usedInTable]="usedInTable">
  <div class="title" *ngIf="!usedInTable">
    {{ title }}
  </div>
  <div class="input-container">
    <input
      [formControl]="formControl"
      [class.disabled]="formControl.disabled"
      class="calendar-control"
      readonly
      [placeholder]="placeHolder"
      aria-label="calendar"
      (keydown.space)="showCalendar($event)"
      (click)="showCalendar($event)"
    />
    <div class="calendar-delete" [class.disabled]="formControl.disabled" (click)="deleteSelectedDate()" *ngIf="formControl.value">
      {{ 'buttons.deleteDate' | translate }}
    </div>
    <img class="calendar-icon" src="assets/images/calendar.svg" (click)="showCalendar($event)" />
    <div class="calendar" *ngIf="calendarShown">
      <div class="calendar-nav">
        <div class="calendar-nav-previous-month">
          <button (click)="changeNavYear(-1)">
            <img [class]="'left'" src="assets/images/chev-right.svg" />
          </button>
        </div>
        <div>{{ navDate.format('YYYY') }}</div>
        <div class="calendar-nav-next-month">
          <button (click)="changeNavYear(1)">
            <img src="assets/images/chev-right.svg" />
          </button>
        </div>
      </div>
      <div class="calendar-nav">
        <div class="calendar-nav-previous-month">
          <button (click)="changeNavMonth(-1)">
            <img [class]="'left'" src="assets/images/chev-right.svg" />
          </button>
        </div>
        <div>{{ navDate.format('MMMM') | titlecase }}</div>
        <div class="calendar-nav-next-month">
          <button (click)="changeNavMonth(1)">
            <img src="assets/images/chev-right.svg" />
          </button>
        </div>
      </div>
      <div class="calendar-container">
        <div class="calendar-header">
          <div class="calendar-date" *ngFor="let day of weekDaysHeaderArr">
            {{ day }}
          </div>
        </div>
        <div class="calendar-body">
          <div *ngFor="let day of gridArr" class="calendar-date" [class.is-disabled]="!day.available">
            <button
              *ngIf="day.value !== 0"
              class="date-item"
              [ngClass]="{ selected: isSelectedDay(day) && day.available }"
              (keydown.space)="selectDay($event, day)"
              (click)="selectDay($event, day)"
            >
              {{ day.value }}
            </button>
            <button *ngIf="day.value === 0" class="date-item"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-error-message *ngIf="formControl.errors && formControl.touched" [validationErrors]="formControl.errors"></app-error-message>
</div>

<input #timePickerInput [format]="24" [ngxTimepicker]="picker" style="visibility: hidden" />
<ngx-material-timepicker
  (closed)="timePickCancelled()"
  [cancelBtnTmpl]="customButtonTemplate"
  (timeSet)="timePickerEvent($event)"
  #picker
></ngx-material-timepicker>
<ng-template #customButtonTemplate>
  <button class="timepicker-button">{{ 'buttons.cancel' | translate }}</button>
</ng-template>
